// src/store/thunks/administrators/deleteAdminThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import { withLoader, withErrorHandling } from '@/store/thunks/thunkWrappers';

export const deleteAdminThunk = createAdminAsyncThunk<
  undefined,
  { id: string }
>(
  'administrators/delete',
  withLoader(
    withErrorHandling(
      async ({ id }, { extra: { administratorsService } }) => {
        await administratorsService.delete(id);
        return undefined;
      }
    )
  )
);
